<script>
import SignaturePad from 'signature_pad'

export default {
  model: {
    event: 'update',
  },

  props: {
    value: { type: String, required: true },
    label: { type: String, default: '' },
    errorMessages: { type: Array, default: () => [] },
  },

  mounted() {
    var vm = this
    this.pad = new SignaturePad(vm.$refs.signPad, {
      onEnd: vm.updateInput,
    })
    // this.pad.fromDataURL(this.value)
  },

  beforeDestroy() {
    this.pad.off()
  },

  methods: {
    clearPad() {
      this.pad.clear()
      this.$emit('update', '')
    },
    updateInput() {
      this.$emit('update', this.pad.toDataURL())
    },
  },
}
</script>

<template>
  <VCard>
    <VCardTitle v-if="label" class="hidden-sm-and-up">
      <VSubheader class="px-0">{{ label }}</VSubheader>
    </VCardTitle>
    <VCardText>
      <VInput v-model="value" :error-messages="errorMessages">
        <canvas ref="signPad"></canvas>
      </VInput>
    </VCardText>
    <VCardActions>
      <VSpacer />
      <VBtn depressed @click="clearPad">Clear</VBtn>
    </VCardActions>
  </VCard>
</template>
